// console.log('Testing...');

const tabsContainer = document.querySelector('.operations__tab-container');
const tabs = document.querySelectorAll('.operations__tab');
const tabsContent = document.querySelectorAll('.operations__content');

// console.log('Tabs container:');
// console.log(tabsContainer);

// console.log('Operations content:');
// console.log(tabsContent);

// console.log('Operations tab:');
// console.log(tabs);

tabsContainer.addEventListener('click', function (e) {
    const clicked = e.target.closest('.operations__tab');
    // console.log(clicked);

    // Guard clause
    if (!clicked) return;

    tabs.forEach(tab => tab.classList.remove('operations__tab--active'));

    clicked.classList.add('operations__tab--active');

    tabsContent.forEach(content => {
        content.classList.remove('operations__content--active');
    });

    // console.log(clicked.dataset.tab);
   document.querySelector(`.operations__content--${clicked.dataset.tab}`).classList.add('operations__content--active');
});

// const phoneEl = document.querySelector('[data-address-field=phone]');
// console.log('Phone input');
// console.log(phoneEl);

// const addressEl = document.querySelector('[data-address-field=address2]');
// console.log(addressEl);
// var myimg = document.getElementById('myimg');
// var text = document.createTextNode("This is my caption.");
// myimg.parentNode.insertBefore(text, myimg.nextSibling)

